import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: block;
}

.mobile-nav__link,
.mobile-nav__summary {
  font-family: "Nanum Myeongjo", "Nanum Gothic", "Malgun Gothic", "Apple SD Gothic Neo", serif;
  letter-spacing: -0.01em;
}

.mobile-nav__link {
  font-weight: 700;
}`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public isActive(link: string) {
        const pathname = location.pathname;
        if (link === '/docs') {
            return pathname === '/docs' || (pathname.startsWith('/docs/') && pathname.startsWith('/docs/history') === false);
        }
        return pathname === link || pathname.startsWith(`${link}/`);
    }

    public async closeMenu() {
        await this.service.status.hide('navbar');
    }

    public async transitionTo(path: string, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();

        if (this.service.status.headerTransition) return;
        if (location.pathname === path) {
            await this.closeMenu();
            return;
        }

        await this.closeMenu();
        await this.service.status.show('headerTransition');

        window.setTimeout(async () => {
            await this.router.navigateByUrl(path);
            window.setTimeout(async () => {
                await this.service.status.hide('headerTransition');
            }, 420);
        }, 260);
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "mobile-nav__link group flex items-center justify-between rounded-[20px] border border-zinc-900 bg-zinc-950 px-4 py-4 text-[16px] font-semibold text-white";
        }
        return "mobile-nav__link group flex items-center justify-between rounded-[20px] border border-gray-200 px-4 py-4 text-[16px] font-semibold text-zinc-700 transition hover:border-zinc-950 hover:text-zinc-950";
    }
}

export default ComponentNavSidebarComponent;